function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "FINAL_LOGO",
  "data-name": "FINAL LOGO",
  transform: "translate(-356.37 -434.577)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M502.42,493.6a21.193,21.193,0,0,1-19.36-13.36,20.409,20.409,0,0,1,5.63-23c4.46-3.97,7.89-8.4,9.02-14.42a16.68,16.68,0,0,0-.06-5.64c-.12-.81-1.08-1.85-.06-2.46.79-.47,1.71.33,2.48.75a47.8,47.8,0,0,1,14.38,11.83,45.031,45.031,0,0,1,9.97,22.52C526.41,483.57,512.32,494.94,502.42,493.6Z",
  fill: "#efe9d9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M706.4,525.14a21.2,21.2,0,0,1-15.32,17.85,20.418,20.418,0,0,1-22.28-8.01c-3.48-4.86-7.53-8.73-13.39-10.48a16.465,16.465,0,0,0-5.62-.53c-.82.04-1.95.88-2.45-.2-.39-.84.51-1.67,1.01-2.39a47.512,47.512,0,0,1,13.27-13.05,45.114,45.114,0,0,1,23.45-7.56C698.95,500.24,708.77,515.44,706.4,525.14Z",
  fill: "#efe9d9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M707.59,625.16c-1.27-1.42-2.53-2.84-3.81-4.24q-18.825-20.7-37.66-41.38c-11.58-12.72-23.21-25.39-34.74-38.16-1.76-1.95-2.86-1.81-4.43.11-3.03,3.72-6.24,7.29-9.37,10.93-2.55,2.96-5.11,5.92-8.2,9.5V511.09q0-13.815-.01-27.63V618.74c.02-13.35.01-26.7.01-40.23a2.526,2.526,0,0,1,1.82,1.15c13.78,14.76,27.59,29.49,41.27,44.33a8.886,8.886,0,0,0,7.26,3.25c14.94-.14,29.88-.06,44.83-.07.72,0,1.45.01,2.17-.03C708.3,627.07,708.74,626.45,707.59,625.16Z",
  fill: "#efe9d9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M609.38,563.88l.26-.07c-.03-.37-.06-.75-.08-1.12a27.411,27.411,0,0,1,.13-4.04l-.32.12V434.83H546.76v4.6h15.08V621.88H547.79v4.6h73.34v-4.6H609.38Z",
  fill: "#efe9d9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M864.95,626.48H806.69l-2.81-21.21a33.472,33.472,0,0,1-12.14,15.72q-8.055,5.49-23.89,5.49-39.615,0-39.61-42.67V506.9H713.93v-4.6h61.84v87.65q0,15.33,2.17,20.19t8.69,4.86q6.51,0,11.63-7.92t5.11-21.98V506.9H791.62v-4.6H850.9V621.68h14.05Z",
  fill: "#efe9d9"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M1020.75,609.22q-16.215-16.725-16.22-46.52t18.23-45.64q18.225-15.84,46.39-15.84,45.585,0,53.32,36.58a17.134,17.134,0,0,1-16.72,20.75h-52.7v9.81q0,24.645,6.29,37.21t21.88,12.57q29.16,0,38.22-31.18l4.53.75q-4.785,18.105-17.22,28.16-12.45,10.065-37.34,10.06Q1036.965,625.96,1020.75,609.22Zm8.67-131.62a20.366,20.366,0,0,1-4.53-13.33,18.478,18.478,0,0,1,4.9-13.07q4.905-5.28,13.58-5.28t13.83,4.65q5.145,4.65,5.15,13.45t-4.9,13.95q-4.905,5.16-14.21,5.15Q1033.955,483.135,1029.42,477.6Zm23.89,75.93h25.9V541.21q0-20.37-2.39-27.78t-9.55-7.42q-7.17,0-10.56,7.92t-3.39,27.28v12.32Zm24.64-75.93a20.366,20.366,0,0,1-4.53-13.33,18.478,18.478,0,0,1,4.9-13.07q4.905-5.28,13.58-5.28t13.83,4.65q5.145,4.65,5.15,13.45t-4.9,13.95q-4.905,5.16-14.21,5.15Q1082.485,483.135,1077.95,477.6Z",
  fill: "#efe9d9"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M998.03,522.49a21.175,21.175,0,0,1-12.88,19.68,20.4,20.4,0,0,1-23.13-5.05c-4.08-4.36-8.59-7.68-14.63-8.66a16.663,16.663,0,0,0-5.64.2c-.81.14-1.82,1.12-2.45.12-.49-.78.29-1.72.69-2.5a47.655,47.655,0,0,1,11.47-14.66,45.078,45.078,0,0,1,22.27-10.53C987.41,498.77,999.12,512.57,998.03,522.49Z",
  fill: "#efe9d9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M932.52,621.75V525.06c0-.29-.01-.58,0-.88V501.24H870.94v4.74h14.05V621.76H870.94v4.74h79.73v-4.74H932.52Z",
  fill: "#efe9d9"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M522.91,619.06c-3.39-6.1-8.92-10.2-14.8-13.57-15.26-8.75-29.69-4.55-43.45,3.79a74.362,74.362,0,0,1-21.58,8.74c-10.89,2.58-17.5-4.06-15.54-14.94.97-5.4-.58-9.67-5.81-12-1.55-.69-4.15-1.28-2.91-3.19,3.4-5.22,1.59-8.29-2.99-11.22-1.42-.91-1.27-3.15-.46-4.81,2.87-5.88.63-9.25-5.06-11.27s-5.6-6.19-3.24-10.68c1-1.91,2.82-3.36,4.13-5.13,7.16-9.73,13.97-19,9.03-32.81-3.77-10.54-4.9-22.05-.02-33.1,3.93-8.89,8.74-17.46,9.05-27.63.05-1.62,1.77-3.58,3.23-4.69,4.42-3.38,8.55-7.29,14.41-8.3,2.05-.35,5.24-.56,4.86-3.65H356.37v6.03H372.1V620.47H356.37v6.03h48v-.03H496.2c7.55,0,15.09.08,22.64-.01C526.34,626.35,526.7,625.88,522.91,619.06Z",
  fill: "#efe9d9"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 767.6,
    height: 192.664,
    viewBox: "0 0 767.6 192.664",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.9f461e41.svg";
export { ForwardRef as ReactComponent };